import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default from 'react';
import style from './Stack.module.css.js';

const Stack = React__default.forwardRef(({ children, className, direction: direction = "row", ...attrs }, ref) => {
    return (jsx("div", { ...attrs, ref: ref, className: classNames(style.stack, direction === "column" && style.column, className), children: children }));
});
Stack.displayName = "Stack";

export { Stack };
//# sourceMappingURL=Stack.js.map
